import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { CardLayoutModule } from 'src/app/common-components/card-layout/card-layout.module';
import { TwoColumnLayoutModule } from 'src/app/common-components/column-layouts/two-column-layout/two-column-layout.module';
import { FileUploadModule } from 'src/app/common-components/file-upload/file-upload.module';
import { TooltipModule } from 'src/app/common-components/tooltip/tooltip.module';
import { UpdateDetailsModule } from 'src/app/common-components/update-details/update-details.module';
import { CallRetentionPolicyPipeModule } from 'src/app/pipes/call-retention-policy-pipe/call-retention-policy-pipe.module';
import { FileUrlPipeModule } from 'src/app/pipes/file-url-pipe/file-url-pipe.module';
import { EntitySelectModule } from '../../common-components/entity-select/entity-select.module';
import { FormFooterModule } from '../../common-components/form-footer/form-footer.module';
import { AddPromptModule } from '../add-prompt/add-prompt.module';
import { ErrorPageModule } from '../error-page/error-page.module';
import { AccountActiveDatesComponent } from './account-active-dates/containers/account-active-dates.component';
import { AccountActiveDatesViewComponent } from './account-active-dates/views/account-active-dates-view.component';
import { AccountLogLevelComponent } from './account-log-level/containers/account-log-level.component';
import { AccountLogLevelViewComponent } from './account-log-level/views/account-log-level-view.component';
import { AdvancedAccountSettingsComponent } from './advanced-account-settings/containers/advanced-account-settings.component';
import { AdvancedAccountSettingsViewComponent } from './advanced-account-settings/views/advanced-account-settings-view.component';
import { AccountDetailComponent } from './containers/account-detail.component';
import { AccountDetailEffects } from './state/account-detail.effects';
import * as fromAccountDetail from './state/account-detail.reducer';
import { AccountDetailViewComponent } from './views/account-detail-view.component';

@NgModule({
   declarations: [
      AccountDetailComponent,
      AccountDetailViewComponent,
      AdvancedAccountSettingsComponent,
      AdvancedAccountSettingsViewComponent,
      AccountLogLevelComponent,
      AccountLogLevelViewComponent,
      AccountActiveDatesViewComponent,
      AccountActiveDatesComponent,
   ],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatRadioModule,
      FileUploadModule,
      FileUrlPipeModule,
      MatCardModule,
      MatMenuModule,
      AddPromptModule,
      MatIconModule,
      MatButtonModule,
      MatTooltipModule,
      LcsLoadingOverlayModule,
      LcsDatepickerModule,
      LcsCallStatePipeModule,
      TwoColumnLayoutModule,
      StoreModule.forFeature(fromAccountDetail.accountDetailFeatureKey, fromAccountDetail.reducer),
      EffectsModule.forFeature([AccountDetailEffects]),
      RouterModule,
      FormFooterModule,
      AppRoutingModule,
      CardLayoutModule,
      UpdateDetailsModule,
      ErrorPageModule,
      EntitySelectModule,
      CallRetentionPolicyPipeModule,
      MatDialogModule,
      TooltipModule,
      CallRetentionPolicyPipeModule,
   ],
})
export class AccountDetailModule {}
